import React from 'react';
import PropTypes from 'prop-types';

import styles from './Stars.module.scss';

const Sizes = {
    Default: '',
    Small: 'small',
    // TODO deprecated, use PascalCase notation instead
    default: '',
    small: 'small'
};

const Stars = ({ rate, size, length = 5, hovering, onClick }) => {

    const getStarClassName = (i) => `${styles.icon} icon icon-star ${Math.round(rate / (100 / length)) > i && styles.active || ''}`;
    const getComponentClassNames = () => `${styles['stars-component']} ${hovering && styles.hovering || ''} ${onClick && styles.click || ''} ${styles[Sizes[size] || Sizes.Default]}`;

    const renderStar = (_, i) => (
        <span
            key={i}
            className={getStarClassName(i)}
            onClick={(e) => onClick && onClick(i + 1, e)}
        />
    );

    return (
        <div className={getComponentClassNames()}>
            {
                Array.from({ length }, renderStar)
            }
        </div>
    );
};

Stars.propTypes = {
    rate: PropTypes.number,
    size: PropTypes.oneOf([
        Sizes.Default,
        Sizes.Small,
    ]),
    length: PropTypes.number,
    hovering: PropTypes.bool,
    onClick: PropTypes.func,
};

export default Stars;
export { Sizes as StarSizes };
